// Dizzplace - minimalna warstwa interakcji. Bez zaleznosci, ES2020.

(() => {
  /* Blokada tla pod arkuszem albo szufladka - JEDNO miejsce dla wszystkich
     okien motywu (menu telefonu, szukanie, koszyk, lista zyczen, dostawa,
     "Podaj ilosc").

     Samo `body { overflow: hidden }` wystarcza w Chrome, bo przegladarka
     przenosi te wlasnosc z body na okno. Safari na iPhonie tego nie robi:
     strona pod zaciemnieniem dalej jedzie pod palcem i sprezynuje przy
     krawedzi, wiec blokujemy OBA elementy - <html> i <body>. Pozycje
     zapamietujemy, bo zablokowanie <html> potrafi zrzucic strone na gore.

     Licznik, bo okna potrafia sie nalozyc (okno dostawy wchodzi PRZED
     szuflada koszyka) i zamkniecie jednego nie moze odblokowac strony,
     dopoki drugie stoi na ekranie. */
  /* Fokus w oknach (audyt na slepo 27.10.2026): okno przekazane do zablokuj()
     trzyma klawisz Tab w sobie, a po zamknieciu fokus wraca na element, z
     ktorego klient je otworzyl - wczesniej Tab wychodzil na strone pod
     zaciemnieniem, a po Escape fokus ladowal na <body>. */
  const FOKUSOWALNE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const widoczny = (el) => el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const fokusowalne = (okno) => [...okno.querySelectorAll(FOKUSOWALNE)].filter(widoczny);
  const okna = [];

  document.addEventListener('keydown', (zdarzenie) => {
    if (zdarzenie.key !== 'Tab' || !okna.length) return;
    const okno = okna[okna.length - 1].okno;
    if (!okno || !okno.isConnected || !widoczny(okno)) return;
    const lista = fokusowalne(okno);
    if (!lista.length) return;
    const pierwszy = lista[0];
    const ostatni = lista[lista.length - 1];
    const teraz = document.activeElement;
    if (!okno.contains(teraz)) {
      zdarzenie.preventDefault();
      (zdarzenie.shiftKey ? ostatni : pierwszy).focus();
    } else if (zdarzenie.shiftKey && teraz === pierwszy) {
      zdarzenie.preventDefault();
      ostatni.focus();
    } else if (!zdarzenie.shiftKey && teraz === ostatni) {
      zdarzenie.preventDefault();
      pierwszy.focus();
    }
  });

  const blokadaTla = {
    licznik: 0,
    stan: null,

    zablokuj(okno) {
      okna.push({ okno: okno || null, powrot: document.activeElement });
      /* Fokus do srodka okna, jesli okno samo go tam nie przenioslo (najpierw
         przycisk albo odnosnik - pole tekstowe na telefonie podnosiloby
         klawiature). Dwie klatki: okna wchodza animacja z `hidden`. */
      if (okno) {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (!okno.isConnected || okno.contains(document.activeElement)) return;
          const lista = fokusowalne(okno);
          const cel = lista.find((el) => el.matches('button, a[href]')) || lista[0];
          if (cel) cel.focus({ preventScroll: true });
        }));
      }
      this.licznik += 1;
      if (this.licznik > 1) return;

      const luka = window.innerWidth - document.documentElement.clientWidth;
      this.stan = {
        pozycja: window.scrollY,
        html: document.documentElement.style.overflow,
        body: document.body.style.overflow,
        odstep: document.body.style.paddingRight,
      };
      document.documentElement.classList.add('tlo-zablokowane');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      // Pasek przewijania znika razem z przewijaniem - bez wyrownania cala
      // strona przeskakuje o jego szerokosc w chwili otwarcia okna.
      if (luka > 0) document.body.style.paddingRight = `${luka}px`;
    },

    odblokuj() {
      if (this.licznik === 0) return;
      const wpis = okna.pop();
      if (wpis && wpis.powrot && wpis.powrot !== document.body && wpis.powrot.isConnected) {
        /* Tylko gdy fokus zostal w zamykanym oknie albo spadl na <body> -
           nie zabieramy go z miejsca, w ktore klient sam kliknal. */
        const teraz = document.activeElement;
        if (!teraz || teraz === document.body || (wpis.okno && wpis.okno.contains(teraz))) {
          requestAnimationFrame(() => wpis.powrot.focus({ preventScroll: true }));
        }
      }
      this.licznik -= 1;
      if (this.licznik > 0) return;

      const stan = this.stan || { pozycja: window.scrollY, html: '', body: '', odstep: '' };
      this.stan = null;
      document.documentElement.classList.remove('tlo-zablokowane');
      document.documentElement.style.overflow = stan.html;
      document.body.style.overflow = stan.body;
      document.body.style.paddingRight = stan.odstep;
      if (Math.abs(window.scrollY - stan.pozycja) > 1) window.scrollTo(0, stan.pozycja);
    },
  };

  window.dizzBlokadaTla = blokadaTla;

  /* ---------- klawiatura ekranowa ---------- */
  /* Safari na iPhonie NIE zmniejsza okna, gdy wjezdza klawiatura - zmienia sie
     tylko „widoczny" obszar (visualViewport). Arkusz przyklejony do dolu ekranu
     zostaje wiec POD klawiatura razem z polem, w ktore klient wlasnie pisze
     (zglaszone na uwagach do zamowienia w szufladzie koszyka: pola nie bylo
     widac i nie dalo sie do niego przewinac).

     Stad jedna zmienna dla calego motywu: --klawiatura to wysokosc zaslonietego
     pasa. Arkusz, ktory chce stac nad klawiatura, odejmuje ja od swojego dolu
     i od wysokosci. Bez visualViewport (starsze przegladarki) zostaje zero,
     czyli zachowanie sprzed zmiany. */
  const sledzKlawiature = () => {
    /* Prog 120 px odsiewa drobne zmiany wysokosci od chowajacego sie paska
       adresu - klawiatura zabiera kilkaset pikseli. */
    const PROG = 120;
    /* Pola, przy ktorych telefon podnosi klawiature. Checkbox, radio i przycisk
       jej nie wolaja, wiec nie ma po co nic chowac. */
    const PISANIE = 'input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]), textarea, [contenteditable=""], [contenteditable="true"]';
    const widok = window.visualViewport;
    let pisze = false;

    const ustaw = () => {
      let luka = 0;
      if (widok) luka = Math.max(0, window.innerHeight - (widok.height + widok.offsetTop));
      document.documentElement.style.setProperty('--klawiatura', `${Math.round(luka)}px`);
      /* DWA sygnaly, bo sam pomiar bywa zawodny: na czesci przegladarek
         mobilnych widoczny obszar nie kurczy sie wcale (klawiatura wjezdza NAD
         strone), a wtedy zostaje sam fakt, ze klient stoi kursorem w polu. */
      document.documentElement.classList.toggle('klawiatura-otwarta', pisze || luka > PROG);
    };

    if (widok) {
      widok.addEventListener('resize', ustaw);
      widok.addEventListener('scroll', ustaw);
    }

    document.addEventListener('focusin', (zdarzenie) => {
      pisze = Boolean(zdarzenie.target.closest && zdarzenie.target.matches(PISANIE));
      ustaw();
    });

    document.addEventListener('focusout', () => {
      pisze = false;
      /* Przeskok miedzy dwoma polami daje focusout przed focusin - krotka
         zwloka nie pozwala paskom mrugnac w tej szczelinie. */
      window.setTimeout(ustaw, 60);
    });

    ustaw();
  };

  sledzKlawiature();

  const initProductGallery = () => {
    document.querySelectorAll('[data-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-gallery-main]');
      if (!main) return;

      const miniatury = [...gallery.querySelectorAll('[data-gallery-thumb]')];

      miniatury.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.getAttribute('data-src');
          const srcset = thumb.getAttribute('data-srcset');
          const alt = thumb.getAttribute('data-alt') || '';
          if (!src) return;
          main.setAttribute('src', src);
          main.setAttribute('alt', alt);
          // Zestaw rozmiarow zostaje: bez niego przegladarka bierze zawsze
          // wariant 1200 px zamiast tego, ktory pasuje do ekranu.
          if (srcset) {
            main.setAttribute('srcset', srcset);
          } else {
            main.removeAttribute('srcset');
          }
          miniatury.forEach((inna) => inna.setAttribute('aria-current', String(inna === thumb)));
        });
      });

      /* Duze wersje pobieramy Z GORY, gdy przegladarka nie ma nic pilniejszego
         do roboty - inaczej zdjecie zaczyna sie sciagac dopiero po kliknieciu
         w miniature i przez chwile widac stare. */
      const dociagnij = () => {
        miniatury.forEach((thumb) => {
          const zapas = new Image();
          zapas.sizes = main.getAttribute('sizes') || '';
          const srcset = thumb.getAttribute('data-srcset');
          if (srcset) zapas.srcset = srcset;
          zapas.src = thumb.getAttribute('data-src') || '';
        });
      };

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(dociagnij, { timeout: 2500 });
      } else {
        window.setTimeout(dociagnij, 1200);
      }
    });
  };

  // Warianty: przepisuje wybor selectow na ukryty input z id wariantu.
  const initVariantPicker = () => {
    document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
      const form = picker.closest('form');
      const idInput = form?.querySelector('[data-variant-id]');
      const priceTarget = document.querySelector('[data-variant-price]');
      const submit = form?.querySelector('[type="submit"]');
      const dataNode = picker.querySelector('[data-variants-json]');
      if (!form || !idInput || !dataNode) return;

      let variants = [];
      try {
        variants = JSON.parse(dataNode.textContent);
      } catch {
        return;
      }

      const sync = () => {
        const chosen = Array.from(picker.querySelectorAll('select')).map((s) => s.value);
        const match = variants.find((v) => v.options.every((o, i) => o === chosen[i]));

        idInput.value = match ? match.id : '';
        if (submit) submit.disabled = !match || !match.available;
        if (priceTarget && match) priceTarget.innerHTML = match.price_html || priceTarget.innerHTML;

        if (match) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        }
      };

      picker.querySelectorAll('select').forEach((s) => s.addEventListener('change', sync));
      sync();
    });
  };

  // Naglowek przyklejony: chowa sie przy przewijaniu w dol, wraca przy w gore.
  // Prog przyklejenia to wysokosc paska zapowiedzi nad naglowkiem - dopoki widac
  // pasek, naglowek stoi w swoim naturalnym miejscu.
  const initStickyHeader = () => {
    const header = document.querySelector('[data-sticky-header]');
    if (!header || header.dataset.stickyReady === 'true') return;
    header.dataset.stickyReady = 'true';

    const spacer = document.querySelector('[data-header-spacer]');
    const drawer = document.getElementById('nav-drawer');
    const MIN_DELTA = 5;

    let baseTop = 0;
    let height = 0;
    let lastScroll = window.scrollY;
    let sticky = false;
    let ticking = false;

    const measure = () => {
      const wasSticky = sticky;
      if (wasSticky) unstick();
      baseTop = header.getBoundingClientRect().top + window.scrollY;
      height = header.offsetHeight;
      if (wasSticky) stick();
    };

    const stick = () => {
      sticky = true;
      header.classList.add('site-header--sticky');
      if (spacer) spacer.style.height = `${height}px`;
    };

    const unstick = () => {
      sticky = false;
      header.classList.remove('site-header--sticky', 'site-header--hidden');
      if (spacer) spacer.style.height = '0px';
    };

    const update = () => {
      ticking = false;
      const y = Math.max(window.scrollY, 0);
      const delta = y - lastScroll;

      if (y <= baseTop) {
        if (sticky) unstick();
        lastScroll = y;
        return;
      }

      if (!sticky) stick();

      // Otwarta szuflada nawigacji trzyma naglowek na wierzchu.
      const drawerOpen = drawer && !drawer.hidden;

      if (Math.abs(delta) >= MIN_DELTA) {
        const hide = delta > 0 && y > baseTop + height && !drawerOpen;
        header.classList.toggle('site-header--hidden', hide);
        lastScroll = y;
      }
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    measure();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
  };

  // Szukajka rozwijana spod naglowka. Przelacznik jest w naglowku i w dolnym
  // menu na telefonie, wiec obsluga siedzi TU, w skrypcie ladowanym na kazdej
  // stronie - wczesniej byla w skrypcie strony glownej i poza nia nie dzialala.
  const initSearchToggle = (root) => {
    root.querySelectorAll('[data-search-toggle]').forEach((przelacznik) => {
      const szuflada = document.querySelector('[data-search-drawer]');
      if (!szuflada || przelacznik.dataset.ready === 'true') return;

      przelacznik.dataset.ready = 'true';
      przelacznik.addEventListener('click', () => {
        szuflada.hidden = !szuflada.hidden;
        if (!szuflada.hidden) szuflada.querySelector('input')?.focus();
      });
    });
  };

  /* Po wyslaniu formularza kontaktowego Shopify wraca na strone z
     `?contact_posted=true#<id formularza>`, a `form.posted_successfully?` jest
     prawdziwe dla KAZDEGO formularza wysylanego na /contact - pytanie
     o produkt, pigulka „Masz jakies pytania?", newsletter. Bez tego wszystkie
     pokazywaly „dziekujemy" naraz, a pigulka sama sie otwierala. Komunikat
     zostaje tylko przy formularzu z kotwicy; gdy kotwicy brak albo nie pasuje
     do zadnego formularza, niczego nie chowamy - lepiej dwa potwierdzenia niz
     zadne. */
  const tylkoWyslanyFormularz = () => {
    const wyslany = decodeURIComponent(window.location.hash.slice(1));
    if (!wyslany) return;
    const formularze = [...document.querySelectorAll('form[action*="/contact"]')];
    if (!formularze.some((formularz) => formularz.id === wyslany)) return;
    formularze.forEach((formularz) => {
      if (formularz.id === wyslany) return;
      formularz.querySelectorAll('.form-status, [data-ask-posted], [data-newsletter-note]').forEach((status) => {
        status.hidden = true;
        status.removeAttribute('data-state');
        if (status.hasAttribute('data-ask-posted')) status.remove();
      });
    });
  };

  /* Przyblizenie zdjecia karty produktu pod myszka: CSS powieksza zdjecie,
     a tu przesuwamy punkt powiekszenia za kursorem, zeby dalo sie obejrzec
     wzor w kazdym miejscu plyty. Delegowane na dokument, bo karty przychodza
     tez z fetcha (filtry kolekcji, lista zyczen, szukanie). */
  const initCardZoom = () => {
    document.addEventListener('pointermove', (zdarzenie) => {
      if (zdarzenie.pointerType !== 'mouse') return;
      const kadr = zdarzenie.target.closest && zdarzenie.target.closest('.product-card__media');
      // Wyprzedany wzor sie nie przybliza - karta jest zablokowana.
      if (!kadr || kadr.closest('.product-card--sold-out')) return;
      /* Karta wczytuje zdjecie na swoj rozmiar, a po powiekszeniu bylby z
         niego rozmyty wzor - przy pierwszym najechaniu prosimy o wieksze. */
      const zdjecie = kadr.querySelector('img[srcset]');
      if (zdjecie && !zdjecie.dataset.zoomSrc) {
        zdjecie.dataset.zoomSrc = '1';
        zdjecie.sizes = `${Math.round(kadr.offsetWidth * 2.6)}px`;
      }
      const r = kadr.getBoundingClientRect();
      const x = ((zdarzenie.clientX - r.left) / r.width) * 100;
      const y = ((zdarzenie.clientY - r.top) / r.height) * 100;
      kadr.style.setProperty('--zoom-x', `${Math.min(100, Math.max(0, x))}%`);
      kadr.style.setProperty('--zoom-y', `${Math.min(100, Math.max(0, y))}%`);
    }, { passive: true });
  };

  initCardZoom();

  const init = () => {
    initStickyHeader();
    initProductGallery();
    initVariantPicker();
    initSearchToggle(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('DOMContentLoaded', tylkoWyslanyFormularz);
  } else {
    init();
    tylkoWyslanyFormularz();
  }

  // Sekcje przeladowywane w edytorze motywu trzeba dowiazac ponownie.
  document.addEventListener('shopify:section:load', init);
})();
